<template>
  <q-card
    class="bg-transparent"
    style="width: 100%;"
    flat
  >
    <kiosk-login
      v-if="$kiosk"
      class="q-pa-md q-mx-auto"
      :class="{
        'bg-responsive': !$q.dark.isActive,
        'bg-transparent': $q.dark.isActive,
        'q-mt-lg': !$isLandscapeView()
      }"
      flat
      style="width: 100%;"
      :style="{ 'max-width': $isLandscapeView() ? '50vw' : '60vw' }"
      :show-login-method-toggle="currentCircuit.kioskOptions.enable_one_time_code_login"
      :request-code="requestCode"
      @code-sent="(val) => $emit('code-sent', val) "
      @login-success="(userId) => $emit('login-success', userId)"
    >
      <template #header>
        <div
          class="text-h6 q-my-sm text-center"
          :style="{ 'font-size': $isLandscapeView() ? '2.4vw' : '2.4vh' }"
          style="line-height: 1.2;"
        >
          <template v-if="membershipRequired">
            {{ $t('checkout.authRequiredForTicketsPromptKiosk') }}
          </template>
          <template v-else>
            {{ $t('auth.alreadyHaveAnAccountQuestion') }}
          </template>
        </div>
        <div
          class="text-body2 q-mb-sm text-center"
          :style="{ 'font-size': $isLandscapeView() ? '1.5vw' : '1.5vh' }"
          style="line-height: 1.2;"
        >
          {{ $t('checkout.scanCardOrSelectOptionPrompt') }}
        </div>
      </template>
      <template #footer>
        <div class="text-center">
          <q-btn
            class="full-width q-mt-lg"
            :size="$isLandscapeView() ? '2vw' : '2vh'"
            :padding="$isLandscapeView() ? '1vw 2vw' : '1vh 2vh'"
            color="primary"
            outline
            :label="$t('checkout.actions.continueAsGuest')"
            data-test-id="continue-as-guest-button"
            @click="$emit('continue-as-guest')"
          />
        </div>
      </template>
    </kiosk-login>

    <login
      v-else
      class="q-pa-lg q-mx-auto bg-transparent text-center justify-center"
      flat
      hide-register-button
      style="width: 100%; max-width: 500px;"
      dense
      :autofocus-enabled="false"
      :consumer-login="!$kiosk"
      :kiosk-login="$kiosk"
      @register="() => $router.push('/register-user')"
      @login-success="(userId) => $emit('login-success', userId)"
    >
      <template #header>
        <div class="text-h6 q-my-sm text-center">
          {{ $t('auth.alreadyHaveAnAccountQuestion') }}
        </div>
      </template>
      <template #default>
        <div class="text-center">
          <div class="text-h6 q-mb-sm">
            {{ $t('checkout.registerPromptTitle') }}
          </div>
          <div
            v-if="hasPointsRewards"
            class="text-body2 q-mb-sm"
          >
            {{ $t('checkout.registerPromptDescription', { rewardsCurrencyName: currentCircuit.rewardsCurrencyName }) }}.
          </div>
        </div>
        <q-btn
          class="full-width q-mb-sm"
          size="lg"
          color="secondary"
          :text-color="$getColor(currentSite, 'secondary')"
          :label="$t('auth.actions.signup')"
          @click="register"
        />
        <q-btn
          class="full-width q-mb-small"
          size="lg"
          color="primary"
          outline
          :label="$t('checkout.actions.continueAsGuest')"
          data-test-id="continue-as-guest-button"
          @click="$emit('continue-as-guest')"
        />
      </template>
    </login>
  </q-card>
</template>

<script>
import Login from 'src/modules/auth/pages/Login'
import KioskLogin from 'src/modules/kiosk/components/KioskLogin'
export default {
  name: 'LoginAndGuestCheckoutCard',
  configuration: ['currentCircuit', 'currentSite', 'membershipTypes'],
  components: {
    Login,
    KioskLogin
  },
  props: {
    membershipRequired: {
      type: Boolean,
      required: false,
      default: false
    },
    requestCode: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['login-success', 'continue-as-guest', 'register', 'code-sent'],
  computed: {
    hasPointsRewards () {
      return _.some(this.membershipTypes.data, membershipType => membershipType.availableOnline && !membershipType.hide && membershipType.membershipPoints?.data?.length > 0)
    }
  },
  methods: {
    register () {
      if (this.$kiosk) {
        this.$emit('register')
        return
      }
      this.$router.push('/register')
    }
  }
}
</script>
